import { Component, Input, OnInit, OnDestroy, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Coverage } from './../../shared';
import { OptionalCoverageComponent, ModalService } from '@bhtp-client-web/component';

@Component({
    selector: 'purchase-optional-coverage',
    template: require('./purchase-optional-coverage.component.html')
})

export class PurchaseOptionalCoverageComponent extends OptionalCoverageComponent {
    constructor(private modalService: ModalService) {
        super();
    }

    public shouldShowLimits(): boolean {
        if (this.coverage.limits && this.coverage.limits.length > 1) {
            return true;
        }

        return false;
    }

    public shouldShowCrcc(): boolean {
        if (<boolean>this.coverageFormGroup.controls['selected'].value && this.coverageFormGroup.controls['carRentalCompany']) {
            return true;
        }

        return false;
    }

    public showCoverageDetails(): void {
        this.modalService.showMessageModal(this.coverage.name, this.coverage.description);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/coverages/purchase-optional-coverage.component.ts